import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { PaginationBarComponent } from './pagination-bar/pagination-bar.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { LoaderComponent } from './loader/loader.component';
import { ColumnMapperComponent } from './column-mapper/column-mapper.component';
import { FileParserComponent } from './file-parser/file-parser.component';
import { TablePreviewerComponent } from './table-previewer/table-previewer.component';
import { AmButtonModule } from '@angularminds/am-button';

const COMPONENTS = [
  LoaderComponent,
  ColumnMapperComponent,
  FileParserComponent,
  TablePreviewerComponent,
];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PipesModule,
    AmButtonModule,
  ],
  declarations: [...COMPONENTS, PaginationBarComponent, FileUploadComponent],
  exports: [...COMPONENTS, PaginationBarComponent, FileUploadComponent],
  entryComponents: [...COMPONENTS, PaginationBarComponent],
})
export class WidgetsComponentsModule {}
